import axios from 'axios';
import router from '@/router.js'

export default({
    state: {
        token: localStorage.getItem('token') || '',
        name: localStorage.getItem('name') || '',
        isAdmin: localStorage.getItem('isAdmin') || '',
        userId: localStorage.getItem('userId') || '',
        subject: localStorage.getItem('subject') || '',
        subjectId: localStorage.getItem('subjectId') || '',
    },

    getters: {
        getToken(state){ return state.token },
        getName(state){ return state.name },
        isAdmin(state){ return state.isAdmin },
        getUserId(state){ return state.userId },
        getCurrentSubject(state){ return state.subject },
        getCurrentSubjectId(state){ return state.subjectId },

        isAuthenticated(state){ return !!state.token; },
        isTeacher(state) { return !state.isAdmin },
        isAdmin(state){ return state.isAdmin },
        isTeacher(state){ return !state.isAdmin },
    },

    mutations: {
        setToken(state, token){
            localStorage.setItem('token', token)
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
            state.token = token
        },
        setName(state, name){
            localStorage.setItem('name', name)
            state.name = name
        },
        setAdmin(state, admin){
            localStorage.setItem('isAdmin', admin)
            state.isAdmin = admin
        },
        setUserId(state, userId){
            localStorage.setItem('userId', userId)
            state.userId = userId
        },
        setCurrentSubject(state, subject){
            localStorage.setItem('subject', subject)
            state.subject = subject
        },
        setCurrentSubjectId(state, subjectId){
            localStorage.setItem('subjectId', subjectId)
            state.subjectId = subjectId
        },

        removeToken(state){
            localStorage.setItem('token', '')
            delete axios.defaults.headers.common['Authorization'];
            state.token = ''
        },
        removeName(state){
            localStorage.setItem('name', '')
            state.name = ''
        },
        removeAdmin(state){
            localStorage.setItem('isAdmin', '')
            state.isAdmin = ''
        },
        removeUserId(state){
            localStorage.setItem('userId', '')
            state.userId = ''
        },
        removeCurrentSubject(state){
            localStorage.setItem('subject', '')
            state.subject = ''
        },
        removeCurrentSubjectId(state){
            localStorage.setItem('subjectId', '')
            state.subjectId = ''
        },
    },

    actions: {
        login({ commit }, credentials){
            commit('setLoading')
            return new Promise((resolve, reject) => {
                axios.post('/login', credentials)
                .then((response) => {
                    const token = response.data.token
                    const name = response.data.fullName
                    const isAdmin = response.data.admin
                    const userId = response.data.id

                    commit('setToken', token)
                    commit('setName', name)
                    commit('setAdmin', isAdmin)
                    commit('setUserId', userId)

                    router.push('/')
                    resolve(response);
                })
                .catch((error) => {
                    commit('removeToken')
                    commit('removeName')
                    commit('removeAdmin')
                    commit('removeUserId')
                    commit('removeCurrentSubject')
                    commit('removeCurrentSubjectId')
                    reject(error)
                })
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        logout({ commit }){
            commit('setLoading')

            axios.get('/logout')
            .then(() => {
                router.push('/login')
            })

            commit('removeToken')
            commit('removeName')
            commit('removeAdmin')
            commit('removeUserId')
            commit('removeCurrentSubject')

            commit('unsetLoading')
        },

        tokenCheck({ commit }, token){
            commit('setLoading')
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
            return new Promise(() => {
                axios.get('/validateToken')
                .then((response) => {
                    const name = response.data.fullName
                    const isAdmin = response.data.admin
                    const userId = response.data.id

                    commit('setName', name)
                    commit('setAdmin', isAdmin)
                    commit('setUserId', userId)
                })
                .catch(() => {
                    commit('removeToken')
                    commit('removeName')
                    commit('removeAdmin')
                    commit('removeUserId')
                    commit('removeCurrentSubject')
                    router.push('/login')
                })
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        /*
        setPassword({ commit, dispatch  }, {token, form}){
            commit('setLoading')
            return new Promise((resolve, reject) => {
                axios.put('/users/validate/' + token, form)
                .then(() => {
                    commit('setToken', token)
                    dispatch('tokenCheck', token)
                    router.push('/')
                })
                .catch((error) => {
                    reject(error)
                })
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },
        */
    }
});
